// @flow
import React, { Component } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';
import { withNavigation } from '@react-navigation/compat';

import theme from '../../../../theme-config';
import I18n from '../../../../lib/i18n';
import { FullButton, Icon, SecondaryFullButton } from '../../../../components/common';
import SelectPreferredNumbersModal from '../components/SelectPreferredNumbersModal';
import AvailablePhonePicker from '../components/AvailablePhonePicker';

export type FlaggedProps = { canSelectPreferredNumbers: boolean };
type Props = {
  selectedNumber: string,
  isFetching: boolean,
  numbers: { ouid: string, phoneNumber: string }[],
  getAvailablePhoneNumbers: Function,
  selectNumber: Function,
  setPickedPhoneNumber: Function,
  navigation: NavigationScreenProp<NavigationRoute>,
  goToNextPage: Function,
} & FlaggedProps;

type State = { preferredNumberModalOpened: boolean };

class PickNumber extends Component<Props, State> {
  state = { preferredNumberModalOpened: false };

  componentDidMount() {
    if (this.props.getAvailablePhoneNumbers) {
      this.props.getAvailablePhoneNumbers();
    }
  }

  showNewNumbers = () => {
    this.props.getAvailablePhoneNumbers();
  };

  onPress = () => (this.props.numbers.length > 0 ? this.pickNumberAndGoToNextPage() : this.showNewNumbers());

  pickNumberAndGoToNextPage = () => {
    this.props.setPickedPhoneNumber(this.props.selectedNumber);
    this.props.goToNextPage();
  };

  openPreferredNumberModal = () => this.setState({ preferredNumberModalOpened: true });
  closePreferredNumberModal = () => this.setState({ preferredNumberModalOpened: false });

  renderRefreshButton = () => {
    return (
      <TouchableOpacity onPress={this.showNewNumbers} style={styles.refreshList} testID={'refreshPhoneNumbersButton'}>
        <Icon name="refresh" size={24} color={theme.signUpLightIconColor} style={styles.refreshIcon} />
      </TouchableOpacity>
    );
  };

  render() {
    return (
      <View style={styles.container}>
        {/* This wrapper forces the picker to stay centered vertically in the available space */}
        <View style={styles.pickerContentArea}>
          <AvailablePhonePicker
            numbers={this.props.numbers}
            isFetching={this.props.isFetching}
            selectedNumber={this.props.selectedNumber}
            selectNumber={this.props.selectNumber}
            renderRefreshButton={this.renderRefreshButton}
          />
        </View>

        <View style={styles.buttons}>
          <FullButton
            text={I18n.t(this.props.numbers.length > 0 || this.props.isFetching ? 'SignUp.ChooseNumber.select' : 'refresh')}
            style={styles.button}
            onPress={this.onPress}
            disabled={this.props.isFetching}
            testID={'selectNumberButton'}
          />
          {this.props.canSelectPreferredNumbers && (
            <View style={styles.secondaryButtonContainer}>
              <SecondaryFullButton
                text={I18n.t('SignUp.ChooseNumber.selectPreferredNumbers')}
                onPress={this.openPreferredNumberModal}
              />
            </View>
          )}
        </View>
        <SelectPreferredNumbersModal
          onRequestClose={this.closePreferredNumberModal}
          visible={this.state.preferredNumberModalOpened}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: { 
    flex: 1, 
    marginHorizontal: 17 
  },
  pickerContentArea: {
    flex: 1, // Takes up all remaining space
    justifyContent: 'center', // Centers vertically
    alignItems: 'center', // Centers horizontally
  },
  buttons: { 
    marginBottom: 16,
    marginTop: 10 
  },
  button: { marginBottom: 8 },
  secondaryButtonContainer: { height: 40 },
  refreshList: { alignItems: 'center', backgroundColor: 'transparent' },
  refreshIcon: { margin: 16 },
});

export default withNavigation(PickNumber);